export const NAME = 'consultationCase';